import React, { Fragment, useContext } from 'react'
import styles from './context-menu.styles'
import injectSheet from 'react-jss'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBirthdayCake } from '@fortawesome/pro-solid-svg-icons/faBirthdayCake'
import { faLevelUp } from '@fortawesome/pro-solid-svg-icons/faLevelUp'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'
import { faUserTimes } from '@fortawesome/pro-solid-svg-icons/faUserTimes'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faFileCheck } from '@fortawesome/pro-solid-svg-icons/faFileCheck'
import { faFileTimes } from '@fortawesome/pro-solid-svg-icons/faFileTimes'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { AppContext } from '../../../app/app'

const ContextMenu = ({
  classes,
  id,
  openAgeGroupDialog,
  openAddToGroupDialog,
  openRemoveFromGroupDialog,
  pupilName,
  retirePupil,
  onIncrementAge,
  editable,
  canUpdatePermissions,
  canPublish,
  addPermission,
  removePermission
}) => {
  const { permissionWarning } = useContext(AppContext)

  return (
    <DropMenu
      popoverClassName={classes.contextMenuHolder}
      button={({ ref, togglePopover }) => (
        <MoreButton forwardedRef={ref} onClick={togglePopover} />
      )}>
      {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
        <Menu className={classes.menu}>
          {editable && (
            <Fragment>
              <MenuItem
                onClick={() => closePopover() && openAgeGroupDialog([id])}>
                <IconHolder>
                  <FontAwesomeIcon icon={faBirthdayCake} />
                </IconHolder>
                Set age group
              </MenuItem>
              <MenuItem
                onClick={() =>
                  closePopover() &&
                  openConfirmationDialog({
                    bodyText: `Are you sure you want to increment age group for ${pupilName}?`,
                    confirmText: 'Increment age group',
                    action: () => onIncrementAge(id)
                  })
                }>
                <IconHolder>
                  <FontAwesomeIcon icon={faLevelUp} />
                </IconHolder>
                Increment age group
              </MenuItem>
              <Separator />
            </Fragment>
          )}
          <MenuItem
            onClick={() => closePopover() && openAddToGroupDialog([id])}>
            <IconHolder>
              <FontAwesomeIcon icon={faUsers} />
            </IconHolder>
            Add to group
          </MenuItem>
          <MenuItem
            onClick={() => closePopover() && openRemoveFromGroupDialog([id])}>
            <IconHolder>
              <FontAwesomeIcon icon={faUserTimes} />
            </IconHolder>
            Remove from group
          </MenuItem>
          {canUpdatePermissions && (
            <Fragment>
              <Separator />
              {canPublish && (
                <MenuItem
                  onClick={() =>
                    closePopover() &&
                    permissionWarning({ action: () => removePermission(id) })
                  }>
                  <IconHolder>
                    <FontAwesomeIcon icon={faFileTimes} />
                  </IconHolder>
                  Remove permission to publish
                </MenuItem>
              )}
              {!canPublish && (
                <MenuItem
                  onClick={() =>
                    closePopover() &&
                    permissionWarning({ action: () => addPermission(id) })
                  }>
                  <IconHolder>
                    <FontAwesomeIcon icon={faFileCheck} />
                  </IconHolder>
                  Add permission to publish
                </MenuItem>
              )}
            </Fragment>
          )}

          {editable && (
            <Fragment>
              <Separator />
              <MenuItem
                onClick={() => {
                  closePopover()
                  openConfirmationDialog({
                    bodyText: `Are you sure you want to retire ${pupilName} ?`,
                    confirmText: 'Retire pupil',
                    action: () => retirePupil(id)
                  })
                }}
                className={classes.retirePupil}>
                <IconHolder>
                  <FontAwesomeIcon icon={faTimes} />
                </IconHolder>
                Retire pupil
              </MenuItem>
            </Fragment>
          )}
        </Menu>
      )}
    </DropMenu>
  )
}

export default injectSheet(styles)(ContextMenu)
